import { render, staticRenderFns } from "./SendBox.vue?vue&type=template&id=555e3a9d"
import script from "./SendBox.vue?vue&type=script&lang=js"
export * from "./SendBox.vue?vue&type=script&lang=js"
import style0 from "./SendBox.vue?vue&type=style&index=0&id=555e3a9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports